export enum ProposalNoteTypeEnum {
    CREDIT_RISK_NOTE = 'CREDIT_RISK_NOTE',
    OPERATIONS_NOTE = 'OPERATIONS_NOTE'
}
